"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getQuickBuyButtonOnClickHandler = require("./getQuickBuyButtonOnClickHandler");
Object.keys(_getQuickBuyButtonOnClickHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getQuickBuyButtonOnClickHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getQuickBuyButtonOnClickHandler[key];
    }
  });
});
